<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">{{ isAT ? "Atividade" : "Tarefa" }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon
              @click="
                () => {
                  dialog = false;
                }
              "
              color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Horas"
              name="horas"
              type="number"
              required
              v-model="payload.horas"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-solution-combobox
              :filter="payload"
              :solutionIds="this.payload.solucaoId"
              v-model="payload"
              @changeSolution="
                (solucaoId) => {
                  this.payload.solucaoId = solucaoId;
                }
              "
            ></app-solution-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>

        <div
          v-for="evidencia in payload.evidencias"
          v-bind:key="evidencia.evidenciaId"
        >
          <v-row>
            <v-col class="separator-list">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Nome da Evidência"
                required
                v-model="evidencia.nome"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                label="Descrição da Evidência"
                required
                v-model="evidencia.descricao"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="separator-list">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col>
            <v-btn
              outlined
              :large="false"
              :color="color"
              class="ml-3"
              @click="addEvidencia"
            >
              <v-icon>{{ icon }}</v-icon
              ><span>Adicionar Evidência</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          outlined
          text
          @click="
            () => {
              dialog = false;
              this.payload = {};
            }
          "
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { taskAPI } from "./TaskAPI";
import { AppSolutionCombobox, solutionAPI } from "@/modules/solution";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalInsertTask",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    solutionId: "",
  },
  computed: {
    ...mapGetters(["isAT"]),
  },
  components: {
    AppSolutionCombobox,
  },
  data() {
    return {
      payload: {
        horas: 0,
        evidencias: [],
        grupoSolucaoId: 0,
        solucaoId: 0,
        tarefaId: 0,
        evidenciaId: 0,
        solutions: [],
        tasks: [],
        evidences: [],
      },
      dialog: false,
    };
  },
  mounted() {
    if (this.object && this.edit === true) {
      this.payload = this.object;
      if (!this.payload.solucaoId && this.payload.solucao)
        this.payload.solucaoId = this.payload.solucao.solucaoId;
      if (!this.payload.evidencias) this.payload.evidencias = [];
    }
    this.loadSolutions();
  },
  methods: {
    onConfirm() {
      if (this.edit === true) {
        taskAPI
          .update(this.payload)
          .then((resp) => {
            this.payload = {};
            this.dialog = false;
            this.$emit("onSave");
          })
          .catch();
      } else {
        taskAPI
          .create(this.payload)
          .then((resp) => {
            this.payload = {};

            this.dialog = false;
            this.$emit("onSave");
          })
          .catch();
      }
    },
    loadSolutions() {
      solutionAPI
        .list()
        .then((resp) => {
          this.solutions = resp.data;
          this.payload.solutions = resp.data;
        })
        .catch((resp) => {
          this.$notification.error(
            `Erro ao listar ${this.isAT ? "Iniciativas" : "Soluções"}`
          );
        });
    },
    addEvidencia() {
      this.payload.evidencias.push({ nome: "", descricao: "" });
      this.$forceUpdate();
    },
  },
  watch: {
    object: {
      handler(val, oldVal) {
        this.payload = val;
        if (!this.payload.solucaoId && this.payload.solucao)
          this.payload.solucaoId = this.payload.solucao.solucaoId;
        if (!this.payload.evidencias) this.payload.evidencias = [];
      },
      deep: true,
    },
    solutionId(solucao) {
      this.payload.solucaoId = solucao;
    },
  },
};
</script>
